export const LIST_AUTO_UPDATE_OPTIONS = {
    'movie:popular': 'Movies: Popular',
    'movie:topRated': 'Movies: Top Rated',
    'movie:upcoming': 'Movies: Upcoming',
    'movie:nowPlaying': 'Movies: Now Playing',
    'tv:popular': 'TV: Popular',
    'tv:topRated': 'TV: Top Rated',
    'tv:airingToday': 'TV: Airing Today',
    'tv:onTheAir': 'TV: Currently Airing',
    '*:latestVideos': 'Movies and TV with most recently published videos',
    'movie:lastAdded': 'Movies: Recently created',
    'tv:lastAdded': 'TV: Recently created',
};
